import React from 'react'


import { connect } from 'react-redux'

function truncateString(str) {
    if (str.length > 15) {
      return str.substring(0, 12) + '...';
    }
    return str;
  }

const TableHeader_Name = ({
    allVideolists,
    selected
}) => {
    const selectedVideoLists = Object.values(selected)

    const selectedVideoList = React.useMemo(() => {
        if (!selectedVideoLists.length)
            return null;


        try {
            return allVideolists.find(el => el.id === selectedVideoLists[0])
        }
        catch (e) {

        }
        return null
    }, [selectedVideoLists, allVideolists])

    return (
        <h2>{selectedVideoList?.name  ? truncateString(selectedVideoList?.name): "ВСЕ ВИДЕО"}</h2>

    )
}


const stateToProps = state => ({
    allVideolists: state.videolists_all.allVideolists,
    selected: state.videolists_all.selected,

})
const actionsToProps = {

}

export default connect(stateToProps, actionsToProps)(TableHeader_Name)